import { RESET_STATE, SET } from "@/stores/CommumActionTypes";
import { SET_SCATTER_CHART } from "./TrendActionsType";
import TrendService from "@/pages/common/trend/service/TrendService";

const actions = {
	[SET]: ({ commit }, params) =>
	{
		const data = TrendService.FormatScatterChartData(params);
		commit(SET, data);
	},
	[RESET_STATE]: ({ commit }) =>
	{
		commit(RESET_STATE);
	},
	[SET_SCATTER_CHART]: ({ commit }, params) =>
	{
		const data = TrendService.FormatScatterChartData(params);
		commit(SET_SCATTER_CHART, data);
	},
};

export default { actions };
